import { computed, ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();
    const router = useRouter();

    const userEmail = computed(() => store.getters.userEmail);

    const isMobile = ref(window.innerWidth <= 768);
    const isExpanded = ref(false);
    const showDropdown = ref(false);

    const handleResize = () => {
      isMobile.value = window.innerWidth <= 768;
      if (!isMobile.value) isExpanded.value = false;
    };

    const toggleMenu = () => {
      isExpanded.value = !isExpanded.value;
    };

    const closeMenu = () => {
      if (isMobile.value) {
        isExpanded.value = false;
      }
    };

    const toggleDropdown = () => {
      showDropdown.value = !showDropdown.value;
    };

    const logout = () => {
      store.dispatch("logoutUser");
      router.push({ name: "login-page" });
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
    });

    return {
      isMobile,
      isExpanded,
      showDropdown,
      userEmail,
      toggleMenu,
      closeMenu,
      toggleDropdown,
      logout,
      isActive: (path) => router.currentRoute.value.path === path,
    };
  },
};
